module.exports = __webpack_public_path__ + "assets/img/reserve-success.409424dc.png";